import { render, staticRenderFns } from "./DotsChart.vue?vue&type=template&id=8e4c0c50&"
import script from "./DotsChart.vue?vue&type=script&lang=js&"
export * from "./DotsChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports